import React from "react";
import Styles from "../shopList.module.scss";

interface ICartTopPrice {
  isOpen: boolean;
  cartItems: any[];
}

function CartTotalCount({ isOpen, cartItems }: ICartTopPrice) {
  function calculateTotalItems() {
    let counter = 0;
    cartItems.forEach((cartItem) => {
      counter += cartItem.itemCount;
    });
    return counter;
  }
  return !isOpen && cartItems.length > 0 ? (
    <span className={Styles.countLabel}>{calculateTotalItems()}</span>
  ) : null;
}

export default React.memo(CartTotalCount);
